import Hero from "../components/home/Hero";
import BookingSurprise from "../components/home/BookingSurprise";
import HowItWorks from "../components/home/HowItWorks";
import Testimonials from "../components/home/Testimonials";
import RestaurantPartner from "../components/home/RestaurantPartner";
import { Helmet } from "react-helmet";
import { useAuth } from "../context/AuthContext";


const Home = () => {
    const { user, isLoading } = useAuth();

    return (
    <>
      <Helmet>
        <title>SurpriseTable - Discover Unexpected Culinary Delights</title>
        <meta
          name="description"
          content="Experience the thrill of dining at premium restaurants for just €15. Let us surprise you with a curated meal worth more than what you pay."
        />
      </Helmet>

      <Hero />
        {!user?.is_restaurant_owner && <BookingSurprise />}
      <HowItWorks />
      <RestaurantPartner />
      <Testimonials />
    </>
  );
};

export default Home;
